import { AnyAction, ThunkAction } from '@reduxjs/toolkit';

import { IPCPFiltersState } from '@/store/redux/reducers/pages/pcp';
import { IReduxActionProps } from '@/store/redux/Utils';
export const DELETE_ALL_FILTERS = 'DELETE_ALL_FILTERS';
export const SET_ALL_FILTERS = 'SET_ALL_FILTERS';
export const SET_PREVIOUS_ROUTE_FILTER = 'SET_PREVIOUS_ROUTE_FILTER';
export const SET_ALL_FILTERS_SETFLAG = 'SET_ALL_FILTERS_SETFLAG';

export * from './facets';
export * from './filters/bodyColors';
export * from './filters/emission';
export * from './filters/equipment';
export * from './filters/fuel';
export * from './filters/interior';
export * from './filters/location';
export * from './filters/merchantLocation';
export * from './filters/price';
export * from './filters/vehicleCondition';
export * from './filters/vehicleType';
export * from './page';

export const deleteAllFilters = (): IReduxActionProps => {
  return {
    type: DELETE_ALL_FILTERS,
  };
};

export const setAllFiltersAndSetFlag =
  (payload: any): ThunkAction<void, IPCPFiltersState, unknown, AnyAction> =>
  (dispatch) => {
    dispatch(setAllFilters(payload));
    dispatch(setAllFiltersSetFlag());
  };

export const setAllFilters = (payload: any): IReduxActionProps => {
  return {
    type: SET_ALL_FILTERS,
    payload,
  };
};

export const setPreviousRouteFilter = (payload: any): IReduxActionProps => {
  return {
    type: SET_PREVIOUS_ROUTE_FILTER,
    payload,
  };
};

export const setAllFiltersSetFlag = (): IReduxActionProps => {
  return {
    type: SET_ALL_FILTERS_SETFLAG,
  };
};
